module.exports = __webpack_public_path__ + "img/jiejue1.53b3f775.png";